import '@/index.css';
import '@/App.css';
import { Desktop } from '@/components/Desktop';
import { Toaster } from '@/components/ui/sonner';

function App() {
  return (
    <div className="App">
      <Desktop />
      <Toaster position="top-right" theme="dark" />
    </div>
  );
}

export default App;